import { Component, OnInit } from '@angular/core';
import {AuthService} from '@service/auth/auth.service';
import {FilterService} from '@service/filter/filter.service';
import { EmitterService } from '@service/emitter/emitter.service';


@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent implements OnInit {
  event = {
    categorie: null,
    code: null,
    count: 10,
    create: null,
    dateD: null,
    dateF: null,
    etat: null,
    max: null,
    min: null,
    name: null,
    autre: null,
    bien: null,
    ordre: "ASC",
    type: "PAIEMENT",
    uuid: null
  }

  type: string = 'PAIEMENT';
  default = "PAIEMENT";
  typeRow = [
    {label: 'Paiement des loyers', value: 'PAIEMENT'},
    {label: 'Paiement lié aux logements', value: 'PAIEMENT-VENTE'},
    {label: 'Contrat de location', value: 'CONTRAT'},
    {label: 'Contrat de vente', value: 'FOLDER'},
    {label: 'Mandat', value: 'MANDAT'},
    {label: 'Reversement', value: 'REVERSEMENT'},
    {label: 'État des lieux', value: 'ETAT'},
    {label: 'Contrat de vente à résilier', value: 'RESILIATION'},
    {label: 'Résiliation de dossier', value: 'RESILIATION-DOSSIER'},
    {label: 'Contrat en attente de renouvellement', value: 'RENOUVELLEMENT'},
    {label: 'Mutation', value: 'MUTATION'}
  ];

  autreTitle = "Bailleur";
  autre: boolean = false;
  autreType = 'ENTITY';
  autreClass= 'Owner';
  autreNamespace= 'Client';
  autreGroups= 'owner';

  bienTitle: string = "Nom du bien"
  bien: boolean = false
  bienType = 'ENTITY';
  bienClass= 'House';
  bienNamespace= 'Client';
  bienGroups= 'house';

  nameTitle: string = "Locataire"
  name: boolean = true;
  nameType = 'ENTITY';
  nameClass= 'Tenant';
  nameNamespace= 'Client';
  nameGroups= 'tenant';

  token = null;
  widget = null;
  datas = [];

  constructor(
    private auth: AuthService,
    private emitter: EmitterService,
    private filterService: FilterService,
  ) {
    this.token = this.auth.getDataToken() ? this.auth.getDataToken() : null;
    this.loadData();
  }

  ngOnInit(): void {
    this.emitter.event.subscribe((data) => {
      if (data.action === 'PAYMENT_VALIDATE') {
        this.widget.pay = this.widget.pay - 1
      }
      if (data.action === 'INVENTORY_VALIDATE') {
        this.widget.inv = this.widget.inv - 1
      }
      if (data.action === 'CONTRACT_ACTIVATE') {
        this.widget.cont = this.widget.cont - 1
      }
      if (data.action === 'RENEW_ACTIVATE') {
        this.widget.renew = this.widget.renew - 1
      }
      if (data.action === 'TERMINATE_ACTIVATE') {
        this.widget.resili = this.widget.resili - 1
      }
      if (data.action === 'MANDAT_VALIDATE') {
        this.widget.mandat = this.widget.mandat - 1
      }
      if (data.action === 'REPAYMENT_VALIDATE') {
        this.widget.repay = this.widget.repay - 1
      }
      if (data.action === 'FOLDER_ACTIVATE') {
        this.widget.fol = this.widget.fol - 1
      }
      if (data.action === 'MUTATE_VALIDATE') {
        this.widget.mutate = this.widget.mutate - 1
      }
      if (data.action === 'FOLDER_TERMINATE_ACTIVATE') {
        // this.widget.mandat = this.widget.mandat - 1
      }
      if (data.action === 'PAYMENT_CUSTOMER_VALIDATE') {
        this.widget.payCl = this.widget.payCl - 1
      }
    });
  }

  onFilter($event) {
    $event.type = this.default;
    this.filterService.type = this.type;
    this.datas = []
    this.filterService.search($event, 'validation', this.token.uuid).subscribe(
      res => {
        this.datas = res
        console.log(this.datas)
        return this.datas
    }, err => { })
  }
  loadData() {
    this.datas = []
    this.filterService.dashboard(this.event, 'validation', this.token.uuid).subscribe(
      res => {
        this.widget = res;
        this.onFilter(this.event);
      }, err => { }
    )
  }
  onChangeLoad(type){
    this.type = type
    this.event.type = type;
    this.name = true;
    this.nameType = 'ENTITY';
    if(type === 'PAIEMENT'){
      this.typeRow = [{label: 'Paiement location', value: 'PAIEMENT'} ];
      this.default = "PAIEMENT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'PAIEMENT-VENTE'){
      this.typeRow = [ {label: 'Paiement vente', value: 'PAIEMENT-VENTE'}];
      this.default = "PAIEMENT-VENTE";
      this.nameTitle = 'Client';
      this.nameClass = 'Customer';
      this.nameNamespace = 'Client';
      this.nameGroups = 'customer';
      this.onFilter(this.event)
    }else if(type === 'CONTRAT'){
      this.typeRow = [{label: 'Contrat de location', value: 'CONTRAT'}];
      this.default = "CONTRAT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'FOLDER'){
      this.typeRow = [{label: 'Dossier de vente', value: 'FOLDER'} ];
      this.default = "FOLDER";
      this.nameTitle = 'Client';
      this.nameClass = 'Customer';
      this.nameNamespace = 'Client';
      this.nameGroups = 'customer';
      this.onFilter(this.event)
    }else if(type === 'MANDAT'){
      this.typeRow = [{label: 'Mandat', value: 'MANDAT'}];
      this.default = "MANDAT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'REVERSEMENT'){
      this.typeRow = [{label: 'Reversement', value: 'REVERSEMENT'}];
      this.default = "REVERSEMENT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'ETAT'){
      this.typeRow = [{label: 'État des lieux', value: 'ETAT'}];
      this.default = "ETAT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'RESILIATION'){
      this.typeRow = [{label: 'Résiliation de contrat', value: 'RESILIATION'} ];
      this.default = "RESILIATION";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'RESILIATION-DOSSIER'){
      this.typeRow = [{label: 'Résiliation de dossier', value: 'RESILIATION-DOSSIER'}];
      this.default = "RESILIATION-DOSSIER";
      this.nameTitle = 'Client';
      this.nameClass = 'Customer';
      this.nameNamespace = 'Client';
      this.nameGroups = 'customer';
      this.onFilter(this.event)
    }else if(type === 'RENOUVELLEMENT'){
      this.typeRow = [{label: 'Renouvellement de contrat', value: 'RENOUVELLEMENT'}];
      this.default = "RENOUVELLEMENT";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }else if(type === 'MUTATION'){
      this.typeRow = [{label: 'MUTATION DE CONTRAT', value: 'MUTATION'}];
      this.default = "MUTATION";
      this.nameTitle = 'Locataire';
      this.nameClass = 'Tenant';
      this.nameNamespace = 'Client';
      this.nameGroups = 'tenant';
      this.onFilter(this.event)
    }
  }

}
